import { DriverFuelType } from '@api/index';

export const ELECTRIC_RESTRICTED_SUMMARY_SECTION_KEYS = new Set<string>([
    'distanceFuelConsumption',
    'idlingConsumption',
]);

export const isRestrictedElectricSummarySection = (sectionKey: string): boolean =>
    ELECTRIC_RESTRICTED_SUMMARY_SECTION_KEYS.has(sectionKey);

export const isElectricOnlySummaryFuelType = (selectedFuelType: DriverFuelType): boolean =>
    selectedFuelType === DriverFuelType.ELECTRIC;

export const isAllSummaryFuelType = (selectedFuelType: DriverFuelType): boolean =>
    selectedFuelType === DriverFuelType.ALL;

export const shouldHideAllSummaryGraphDataForElectricOnly = (
    sectionKey: string,
    selectedFuelType: DriverFuelType
): boolean => isElectricOnlySummaryFuelType(selectedFuelType) && isRestrictedElectricSummarySection(sectionKey);

export const shouldHideElectricSummaryGraphData = (sectionKey: string, selectedFuelType: DriverFuelType): boolean =>
    isRestrictedElectricSummarySection(sectionKey) &&
    (isElectricOnlySummaryFuelType(selectedFuelType) || isAllSummaryFuelType(selectedFuelType));
